module.exports = __webpack_public_path__ + "static/media/slider-gif5.ffafb456.gif";